import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import moment from 'moment';
import * as _ from 'lodash';
import convertPost from '../../helpers/convertPost';
import { connect } from 'react-redux';
import { parseLink } from 'redux/modules/parsedLinks';
import { clearUpcomingContentTemplate } from 'redux/modules/reportUpcomingContent';
import Gauge from 'react-radial-gauge';
import { EmptyState, PostListItem, PostPlatformPreview, Spinner, Video } from 'components';
import * as styles from './UpcomingContentPreview.scss';
var UpcomingContentPreview = (_dec = connect(function (state) {
  return {
    reports: state.reporting.reports,
    partnerTheme: state.reportBuilder.partnerTheme && state.reportBuilder.partnerTheme.details ? state.reportBuilder.partnerTheme.details : null,
    selectedClient: state.reportBuilder.selectedClient,
    parsedLinks: state.parsedLinks,
    gettingPosts: state.reportUpcomingContent.gettingPosts
  };
}, {
  clearUpcomingContentTemplate: clearUpcomingContentTemplate,
  parseLink: parseLink
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(UpcomingContentPreview, _Component);

  var _super = _createSuper(UpcomingContentPreview);

  function UpcomingContentPreview(props) {
    var _this;

    _classCallCheck(this, UpcomingContentPreview);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "formatPostiveNegative", function (number) {
      return number < 0 ? number : "+ ".concat(number);
    });

    _defineProperty(_assertThisInitialized(_this), "getIcons", function (accounts) {
      var iconClass = {
        instagram: 'fa-instagram',
        googleMyBusiness: 'fa-google',
        facebookPage: 'fa-facebook-square',
        facebookProfile: 'fa-facebook-square',
        linkedInCompany: 'fa-linkedin-square',
        linkedInProfile: 'fa-linkedin-square',
        twitter: 'fa-twitter-square'
      };
      var iconColor = {
        googleMyBusiness: '#4285f4',
        facebookPage: '#3b5998',
        facebookProfile: '#3b5998',
        linkedInCompany: '#007bb5',
        linkedInProfile: '#007bb5',
        twitter: '#55acee',
        instagram: '#3f729b'
      };
      return accounts.map(function (key, index) {
        return /*#__PURE__*/React.createElement("i", {
          className: "fa ".concat(iconClass[key], " ").concat(styles.saIcon),
          style: {
            color: iconColor[key]
          },
          key: "postingToIcon_".concat(key, "_").concat(index)
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderPreview", function (post, previewType) {
      // make platform a top level thing
      post.accounts = post && post.QueueId ? [_.camelCase(post.Queue.type)] : post.SocialAccountPosts.map(function (sa) {
        return _.camelCase(sa.SocialAccount.platform);
      });
      var hasImages = post.S3Files && post.S3Files.length ? [post.S3Files[0].fullyQualifiedUrl] : null;
      var postType = 'textPost';

      if (post.linkUrl) {
        postType = 'linkPost';
      } else if (hasImages) {
        postType = 'imagePost';
      } else if (post.videoUrl) {
        postType = 'videoPost';
      }

      if (postType === 'linkPost') {
        if (_this.props.parsedLinks[post.linkUrl]) {
          post.linkData = _this.props.parsedLinks[post.linkUrl];
        } else {
          _this.props.parseLink(post.linkUrl);
        }
      }

      if (previewType === 'platformPreview') {
        return _this.renderPlatformPreview(post, postType);
      } else if (previewType === 'listPreview') {
        return _this.renderListPreview(post, postType);
      } else if (previewType === 'textOnly') {
        return _this.renderTextPreview(post, postType);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderTextPreview", function (post, postType) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#616161',
          flex: '0 0 100px'
        }
      }, moment(post.publishAt).format('MM/DD/YYYY'), ":"), /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#616161',
          flex: 1
        }
      }, postType === 'linkPost' && post.linkData ? post.linkData.parsing ? 'Loading...' : post.linkData.description : post.message));
    });

    _defineProperty(_assertThisInitialized(_this), "renderListPreview", function (post, postType) {
      var imageUrl = post.S3Files.length ? post.S3Files[0].fullyQualifiedUrl : '';
      var numImgs = post.S3Files.length ? post.S3Files.length : '';
      var postingToIcons = /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 8
        }
      }, post.accounts && _this.getIcons(post.accounts));
      return /*#__PURE__*/React.createElement(PostListItem, {
        aboveLeftContent: post.QueueId ? null : 'Custom Content',
        aboveLeftContentStyle: {
          color: _this.props.partnerTheme ? _this.props.partnerTheme.primaryColor : '#ef7521',
          marginBottom: 8,
          fontSize: 13
        },
        belowMessageContent: postType === 'linkPost' ? /*#__PURE__*/React.createElement("a", {
          href: post.linkUrl,
          style: {
            color: '#1f5180',
            textDecoration: 'none',
            fontSize: 13
          },
          target: "_blank"
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-link",
          style: {
            marginRight: 6
          }
        }), "Link Post") : postType === 'videoPost' ? /*#__PURE__*/React.createElement("span", {
          style: {
            fontSize: 13
          }
        }, "Video Post") : null,
        borderLeft: {
          borderLeft: '1px solid green'
        },
        message: post.message ? post.message : postType === 'linkPost' && post.linkData ? post.linkData.parsing ? 'Loading...' : post.linkData.description : 'No message',
        postingToIcons: postingToIcons,
        image: function () {
          if (postType === 'linkPost' && !imageUrl) {
            if (post.linkData && !post.linkData.parsing && post.linkData.imageUrl) {
              return post.linkData.imageUrl;
            }
          }

          return imageUrl;
        }(),
        numImgs: numImgs,
        videoUrl: post.videoUrl,
        publishAt: post.publishAt,
        wrapStyle: {
          display: 'flex'
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderPlatformPreview", function (post, postType) {
      var videoTags = post.videoUrl ? /*#__PURE__*/React.createElement(Video, {
        src: "".concat(post.videoUrl, "#t0.1"),
        style: {
          width: '100%',
          height: '100%'
        }
      }) : null;
      var imgTags = post.videoUrl ? null : post.S3Files.map(function (file, idx) {
        var url = file.fullyQualifiedUrl;
        var styleObj = {
          backgroundImage: "url(".concat(url, ")"),
          backgroundPosition: 'center center',
          paddingBottom: '100%',
          backgroundRepeat: 'no-repeat',
          backgroundSize: post.S3Files.length > 1 ? 'cover' : 'contain',
          display: 'inline-block',
          width: '100%'
        };
        var classColSize = 12;

        if (post.S3Files.length === 4) {
          classColSize = 6;
          styleObj.paddingBottom = '50%';
        } else if (post.S3Files.length === 2) {
          classColSize = 12;
          styleObj.paddingBottom = '50%';
        } else if (post.S3Files.length === 3) {
          if (idx === 1 || idx === 2) {
            classColSize = 6;
          } else {
            classColSize = 12;
          }

          styleObj.paddingBottom = '50%';
        }

        if (post.S3Files.length > 1) {
          return /*#__PURE__*/React.createElement("div", {
            key: idx,
            className: "col-xs-".concat(classColSize),
            style: styleObj
          });
        }

        return /*#__PURE__*/React.createElement("div", {
          key: idx,
          className: "col-xs-".concat(classColSize)
        }, /*#__PURE__*/React.createElement("img", {
          src: url,
          style: {
            maxWidth: '100%'
          }
        }));
      });
      var imgContainer = postType === 'linkPost' ? /*#__PURE__*/React.createElement("div", {
        style: {
          backgroundImage: "url(".concat(post.linkData.parsing ? '' : post.linkData.imageUrl, ")"),
          paddingBottom: '50%',
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
          borderBottom: '1px solid #DBDBDB'
        }
      }) : null;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '0 0 100px',
          fontSize: 14,
          lineHeight: '18px',
          alignSelf: 'center',
          color: '#616161',
          marginRight: 24
        }
      }, !post.QueueId && /*#__PURE__*/React.createElement("div", {
        style: {
          color: _this.props.partnerTheme ? _this.props.partnerTheme.primaryColor : '#ef7521',
          fontSize: 13,
          marginBottom: 8
        }
      }, "Custom Content"), moment(post.publishAt).format('dddd M/D/YYYY'), " at ", moment(post.publishAt).format('h:mm A'), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 8
        }
      }, post.accounts && _this.getIcons(post.accounts))), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '0 0 75%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          maxWidth: 500
        }
      }, postType !== 'linkPost' ? /*#__PURE__*/React.createElement("div", {
        className: styles.facebook_preview,
        style: post.QueueId ? {} : {
          borderColor: _this.props.partnerTheme ? _this.props.partnerTheme.primaryColor : '#ef7521',
          borderWidth: 2,
          borderRadius: 2
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.fb_post
      }, /*#__PURE__*/React.createElement("p", {
        className: styles.fb_post_p
      }, " ", post.message, " "), /*#__PURE__*/React.createElement("div", {
        className: styles.img_container
      }, imgTags, videoTags), postType === 'videoPost' && /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: 13
        }
      }, "Video Post"))) : /*#__PURE__*/React.createElement("div", {
        className: styles.facebook_preview,
        style: post.QueueId ? {} : {
          borderColor: _this.props.partnerTheme ? _this.props.partnerTheme.primaryColor : '#ef7521',
          borderWidth: 2,
          borderRadius: 2
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.fb_post
      }, /*#__PURE__*/React.createElement("p", {
        className: styles.fb_post_p
      }, " ", post.message, " "), /*#__PURE__*/React.createElement("div", {
        className: styles.img_container
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          border: '1px solid #DBDBDB',
          textAlign: 'left'
        }
      }, imgContainer, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: '5px'
        }
      }, post.linkData && post.linkData.title && /*#__PURE__*/React.createElement("h4", {
        style: {
          fontSize: '1.3em',
          fontFamily: 'Times New Roman',
          marginTop: 10,
          marginBottom: 0
        }
      }, post.linkData.title), post.linkData && post.linkData.description && /*#__PURE__*/React.createElement("p", {
        style: {
          fontSize: '0.8em'
        }
      }, post.linkData.description), post.linkData && post.linkData.caption && /*#__PURE__*/React.createElement("small", {
        style: {
          color: '#a6a6a6',
          fontSize: '0.7em'
        }
      }, post.linkData.linkCaption.toUpperCase()), /*#__PURE__*/React.createElement("a", {
        href: post.linkUrl,
        style: {
          color: '#1f5180',
          textDecoration: 'none',
          fontSize: 13
        },
        target: "_blank"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-link",
        style: {
          marginRight: 6
        }
      }), "Link Post")))))))));
    });

    _this.state = {
      clean: true
    };
    return _this;
  }

  _createClass(UpcomingContentPreview, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.clean && this.props.gettingPosts) {
        console.log('about to set state to not clean');
        this.setState({
          clean: false
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.clearUpcomingContentTemplate();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          partnerTheme = _this$props.partnerTheme,
          template = _this$props.template,
          reports = _this$props.reports,
          selectedClient = _this$props.selectedClient;
      var selectedPreviewTypeIndex = template.sections.find(function (section) {
        return section.key === 'previewType';
      }).value;
      var previewTypeKey = template.previewType[selectedPreviewTypeIndex].key;
      var showCustomPosts = template.postTypesToShow.find(function (t) {
        return t.key === 'customPosts';
      }).value;
      var showQueuedPosts = template.postTypesToShow.find(function (t) {
        return t.key === 'queuePosts';
      }).value;
      var filteredPosts = !showQueuedPosts ? template.posts.filter(function (post) {
        return !post.QueueId;
      }) : template.posts;
      filteredPosts = !showCustomPosts ? filteredPosts.filter(function (post) {
        return post.QueueId;
      }) : filteredPosts;
      filteredPosts = filteredPosts.filter(function (post) {
        return post.value;
      }); // sort by publishAt to interweave custom and queue posts

      filteredPosts = _.sortBy(filteredPosts, function (o) {
        return new moment(o.publishAt);
      });
      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 16
        }
      }, this.props.gettingPosts && /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 75
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })), !this.props.gettingPosts && !this.state.clean && !filteredPosts.length && /*#__PURE__*/React.createElement(EmptyState, {
        text: "No content for this date range.",
        iconName: "fa fa-history",
        iconSize: "95px",
        style: {
          marginTop: 24
        }
      }), !this.props.gettingPosts && !!filteredPosts.length && /*#__PURE__*/React.createElement("div", null, !!filteredPosts.length && filteredPosts.map(function (post, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: "postPreview_".concat(index),
          style: {
            borderTop: '1px solid #e1e1e1',
            padding: 24,
            borderLeft: post.QueueId ? 0 : previewTypeKey === 'platformPreview' ? 0 : "4px solid ".concat(partnerTheme ? partnerTheme.primaryColor : '#ef7521', " ")
          }
        }, _this2.renderPreview(post, previewTypeKey));
      })));
    }
  }]);

  return UpcomingContentPreview;
}(Component)) || _class);
export { UpcomingContentPreview as default };